import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import ListItem from '@material-ui/core/ListItem';

import ListItemText from '@material-ui/core/ListItemText';

import MenuItem from '@material-ui/core/MenuItem';

import { Link } from 'react-router-dom'




class DialogPublicados extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            open:true,
            openList: false

        } 
    }

      handleClose = () => {

        this.setState({ open: false });
      };

    render() {

        
        return (
            <div>
                <Dialog
                  open={true}
                  onClose={this.handleClose}
                  aria-labelledby="form-dialog-title"
                >
                <DialogTitle id="form-dialog-title">Seleccione Catálogo</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      A continuación, seleccione el catalogo publicado destino.
                    </DialogContentText>

            
                <TextField
                  id="publicados"
                  select
                  label="Select"          
                  value={this.props.selectedIndexPublicados}
                  onChange= {this.props.handleChangePublicados}
                  style={{width:'100%'}}
                  helperText="Seleccionar Catálogo"
                  margin="normal"
                >
                
                {this.props.publicados.map(item => (
                  <MenuItem key={item.idCatalogo} value={item.idCatalogo}>
                    {item.nombre}
                  </MenuItem>
                    ))}
                  </TextField>
            
                </DialogContent>
                  <DialogActions>
                    <Button onClick={this.props.handleCancelButton} className="btnSecundario">
                      Cancelar
                    </Button>

                    <Button onClick={this.props.handleOnTrasladar} className="btnPrincipal">
                      Continuar
                    </Button>
                  </DialogActions>
                </Dialog>
          </div>
        )
    }
}



DialogPublicados.defaultProps = {
    publicados: []
}

export default DialogPublicados